import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ModuleService } from '../services/module.service';

@Injectable()
export class ModuleResolver  {
  constructor(private moduleService: ModuleService) {}

  /**
   * Make sure the modules are loaded before accessing the route
   */
  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.moduleService.loadModules();
  }
}
